import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters/Animated'
import './contact.scss'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  
 
  useEffect(() => {
    let timeout;
  
    timeout = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_aegcmc4', 'template_iywb31u', e.target, 'bcuMm69IRuIwdDT8J')
    .then(
      () => {
        alert('Message successfully sent!')
        window.location.reload(false)
      },
      () => {
        alert('Failed to send the message, please try again')
      }
    )
  };
  

   
  


  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am interested in freelance opportunities - especially on ambitious
            or large projects. However, if you have any other requests or
            questions, don't hesitate to contact me using below form either.
          </p>
          <div className="contact-form">
            <form onSubmit={sendEmail} >
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required 
                 />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                    
                  />
                </li>
               
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                    
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="hire-me" value="SEND"  />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Wael Abednebi,
          <br />
          Tunisia ,
          <br />
          Tunis <br />
           L'aouina <br />
          <br />
          <span>waelabednebi3@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[36.851952, 10.264496]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[36.851952, 10.264496]}>
              <Popup>Wael lives here, come over for a cup of coffee :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
